var _path, _path2, _path3, _mask, _ellipse, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConnected = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 11.5817C3.81436 9.60072 6.16613 8.02932 8.7544 6.95722C11.3427 5.88512 14.1168 5.33331 16.9183 5.33331C19.7199 5.33331 22.494 5.88511 25.0822 6.95721C27.6705 8.02931 30.0223 9.60072 32.0033 11.5817",
    stroke: "#048263",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54688 16.2958C7.9088 14.9338 9.52564 13.8535 11.3051 13.1164C13.0845 12.3794 14.9917 12 16.9178 12C18.8438 12 20.751 12.3794 22.5305 13.1164C24.3099 13.8535 25.9267 14.9338 27.2887 16.2958",
    stroke: "#048263",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2617 21.0098C12.0046 20.267 12.8865 19.6777 13.8571 19.2757C14.8277 18.8736 15.868 18.6667 16.9186 18.6667C17.9691 18.6667 19.0094 18.8736 19.98 19.2757C20.9506 19.6777 21.8326 20.267 22.5754 21.0098",
    stroke: "#048263",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_2646_14863",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9179,
    cy: 26,
    rx: 1.33333,
    ry: 1.33333
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9179,
    cy: 26,
    rx: 1.33333,
    ry: 1.33333,
    fill: "#048263"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7513 26C15.7513 25.3557 16.2736 24.8334 16.9179 24.8334V29.8334C19.035 29.8334 20.7513 28.1171 20.7513 26H15.7513ZM16.9179 24.8334C17.5623 24.8334 18.0846 25.3557 18.0846 26H13.0846C13.0846 28.1171 14.8008 29.8334 16.9179 29.8334V24.8334ZM18.0846 26C18.0846 26.6444 17.5623 27.1667 16.9179 27.1667V22.1667C14.8008 22.1667 13.0846 23.8829 13.0846 26H18.0846ZM16.9179 27.1667C16.2736 27.1667 15.7513 26.6444 15.7513 26H20.7513C20.7513 23.8829 19.035 22.1667 16.9179 22.1667V27.1667Z",
    fill: "#048263",
    mask: "url(#path-4-inside-1_2646_14863)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Connected.c46b316bebbbfd4a8da707f095eeffb5.svg";